export default __webpack_public_path__ + "static/media/KOD0115-min.a835eaaa.webp";